import gql from 'graphql-tag';

export const followRecordsMutation = gql`
  mutation FollowRecords($input: FollowRecordsMutationInput!) {
    followRecords(input: $input) {
      userErrors {
        path
        message
      }
    }
  }
`;
